import { z } from "zod";

const ProjectCountSchema = z.object({
  project_id: z.number(),
  count: z.number(),
  region: z.string(),
});

const DatasetBaseSchema = z.object({
  id: z.number(),
  name: z.string(),
  type_list: z.array(z.number()),
  timestamp: z.string().nullable(),
  approved_customers: z.array(z.number()),
  non_included_customers: z.array(z.number()),
  synthetic_customers: z.array(z.number()),
});

const DatasetDetailExtension = {
  image_count: z.number(),
  project_counts: z.array(ProjectCountSchema),
} as const;

export const DatasetSchema = DatasetBaseSchema.extend({
  sensitive: z.boolean(),
  crop: z.boolean(),
});

export type Dataset = z.infer<typeof DatasetSchema>;

export const DatasetDetailSchema = DatasetSchema.extend(DatasetDetailExtension);

export type DatasetDetail = z.infer<typeof DatasetDetailSchema>;

export const DefectDatasetSchema = DatasetBaseSchema;

export type DefectDataset = z.infer<typeof DefectDatasetSchema>;

export const DefectDatasetDetailSchema =
  DefectDatasetSchema.extend(DatasetDetailExtension);

export type DefectDatasetDetail = z.infer<typeof DefectDatasetDetailSchema>;

export const DatasetImageSchema = z.object({
  id: z.number(),
  project_id: z.number(),
  name: z.string(),
  width: z.number().nullable(),
  height: z.number().nullable(),
  src: z.string(),
  region: z.string(),
});

export type DatasetImage = z.infer<typeof DatasetImageSchema>;

// One ImageObjectType row attached to a bounding box. `object_type_id`
// references an ObjectType (name/colour) — already cached via /object_types.
export const AnnotationTypeSchema = z.object({
  id: z.number(),
  object_type_id: z.number(),
  workflow_status: z.number().nullable(),
});

export type AnnotationType = z.infer<typeof AnnotationTypeSchema>;

// A bounding box (ImageObject). Coordinates are normalised to [0, 1]: x/y is
// the top-left corner, width/height the box size; rotation is in degrees.
export const ImageAnnotationSchema = z.object({
  id: z.number(),
  x: z.number(),
  y: z.number(),
  width: z.number(),
  height: z.number(),
  rotation: z.number().nullable(),
  types: z.array(AnnotationTypeSchema),
});

export type ImageAnnotation = z.infer<typeof ImageAnnotationSchema>;
